import { makeAutoObservable } from "mobx";

import { ILanguageOption, ITranscriptionUploadFile } from "../models/interfaces";

export class TranscriptionStore {
  private _uploadedFiles: ITranscriptionUploadFile[] = [];
  private _currentProgressingFileIds: string[] = [];

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
  }

  public get uploadedFiles(): ITranscriptionUploadFile[] {
    return this._uploadedFiles;
  }

  public setUploadedFiles(value: ITranscriptionUploadFile[]) {
    this._uploadedFiles = value;
  }

  public get isAnyFileProgressing(): boolean {
    return this._currentProgressingFileIds.length > 0;
  }

  public getUploadedFileById(fileId: string | undefined): ITranscriptionUploadFile | undefined {
    return this._uploadedFiles.find(f => f.id === fileId);
  }

  public setUploadedFileOutputLanguage(fileId: string, value: ILanguageOption): void {
    const file = this.getUploadedFileById(fileId);
    if (!file) {
      return;
    }

    file.outputLanguage = value;
  }

  public setUploadedFileSelectedSpeakerCount(
    fileId: string,
    value: ITranscriptionUploadFile["selectedSpeakerCount"],
  ): void {
    const file = this.getUploadedFileById(fileId);
    if (!file) {
      return;
    }

    file.selectedSpeakerCount = value;
  }

  public setUploadedFileSpeakerRecognitionMode(
    fileId: string,
    value: ITranscriptionUploadFile["speakerRecognitionMode"],
  ): void {
    const file = this.getUploadedFileById(fileId);
    if (!file) {
      return;
    }

    file.speakerRecognitionMode = value;
  }

  public setUploadedFileResult(fileId: string, result: ITranscriptionUploadFile["result"] | undefined): void {
    const file = this.getUploadedFileById(fileId);
    if (!file) {
      return;
    }

    file.result = result;
  }

  public addProgressingFile(fileId: string): void {
    if (this.containsProgressingFile(fileId)) {
      return;
    }

    this._currentProgressingFileIds = [...this._currentProgressingFileIds, fileId];
  }

  public removeProgressingFile(fileId: string): void {
    this._currentProgressingFileIds = this._currentProgressingFileIds.filter(
      progressingFileId => progressingFileId !== fileId,
    );
  }

  public containsProgressingFile(fileId: string): boolean {
    return this._currentProgressingFileIds.some(progressingFileId => progressingFileId === fileId);
  }
}
